import {InventoryPlotEdit} from '@/admin/resources/inventoryPlots/InventoryPlots';

export default {
  edit: InventoryPlotEdit,
};
